import React from 'react';

import TextInput from './TextInput';
import NumericInput from './NumericInput';
import RadioInput from './RadioInput';
import CheckboxesInput from './CheckboxesInput';
import BooleanInput from './BooleanInput';
import DateTimeInput from './DateTimeInput';
import ImageInput from './ImageInput';
import CatalogInput from './CatalogInput';
import MultiCatalogInput from './MultiCatalogInput';
import MultiNumericInput from './MultiNumericInput';
import RadioButtonsHorizontal from './RadioButtonsHorizontal';
import {getQuestionMetadata, getMeasurementUnitLabel} from '../../screens/FormBuilderScreen/shared';

function AnswerInput(props) {
  const {question, label} = props;

  switch (question.type) {
    // CODE_GENERATOR codes are generated server-side at submission time. Render
    // text-like so the value displays without crashing; the dashboard never authors it.
    case 'CODE_GENERATOR':
    case 'SCANNED_CODE':
    case 'TEXT':
      return <TextInput {...props} />;
    case 'NUMERIC':
      return <NumericInput {...props} />;
    case 'MEASURED_NUMERIC': {
      const unit = getMeasurementUnitLabel(question);
      const labelWithUnit = label && unit ? `${label} (${unit})` : label;
      return <NumericInput {...props} label={labelWithUnit} />;
    }
    case 'RADIO':
      return getQuestionMetadata(question, 'displayHorizontal').includes('true') ? <RadioButtonsHorizontal {...props} /> : <RadioInput {...props} />;
    case 'CHECKBOXES':
      return <CheckboxesInput {...props} />;
    case 'BOOLEAN':
      return <BooleanInput {...props} />;
    case 'DATETIME':
      return <DateTimeInput {...props} />;
    case 'IMAGE':
      return <ImageInput {...props} />;
    case 'CATALOG_RADIO':
      return <CatalogInput {...props} />;
    case 'CATALOG_CHECKBOX':
      return <MultiCatalogInput {...props} />;
    case 'MULTI_NUMERIC':
      return <MultiNumericInput {...props} />;
    default:
      throw new Error(`Unhandled question type: ${question.type}`);
  }
}

export default AnswerInput;